<template>
  <PageHeader
    title="Identity Access Management Console"
    subtitle="Manage users, roles, and permissions within the system"
    :breadcrumbs="[{ label: 'Admin Console' }]"
  >
    <template #bottom>
      <Page_Tabs
        :tabs="tabLabels"
        :initial-tab="activeTabLabel"
        class="px-6 pt-4"
        no-border
        @select="handleTabSelect"
      />
    </template>
  </PageHeader>

  <div class="p-4">
    <!-- Manage Users -->
    <div v-if="activeTab === 'users'">
      <User_Access_Table />
    </div>

    <!-- Role Configurations -->
    <div v-else-if="activeTab === 'roles'">
      <Config_Roles />
    </div>

    <!-- Audit Logs -->
    <div v-else-if="activeTab === 'audit'">
      <User_Activity_Table />
    </div>
  </div>
</template>

<script>
import User_Access_Table from '@/components/Lists/User_Access_Table.vue';
import User_Activity_Table from '@/components/Lists/User_Activity_Table.vue';
import Config_Roles from '@/components/forms/Config_Roles.vue';
import { FEATURES } from '@/constants/features';
import { canAccessFeature } from '@/utils/access';
import { mapGetters } from 'vuex';
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue';
import Page_Tabs from '@/components/widgetcomponents/Page_Tabs.vue';

export default {
  name: 'IAMConsole',
  components: {
    User_Access_Table,
    User_Activity_Table,
    Config_Roles,
    PageHeader,
    Page_Tabs
  },
  data() {
    return {
      activeTab: 'users',
    };
  },
  computed: {
    ...mapGetters('auth', ['current_user']),
    ...mapGetters('tenant', ['isSecurityUser']),
    canConfigRoles() {
      return canAccessFeature(FEATURES.ACTION_ROLE_CONFIG);
    },
    canViewAuditLog() {
      return canAccessFeature(FEATURES.MODULE_ADMIN_AUDIT_LOG);
    },
    tabs() {
      const items = [
        { key: 'users', label: 'Manage Users' },
      ];
      if (this.canConfigRoles) {
        items.push({ key: 'roles', label: 'Role Configurations' });
      }
      if (this.canViewAuditLog) {
        items.push({ key: 'audit', label: 'Audit Logs' });
      }
      return items;
    },
    tabLabels() {
      return this.tabs.map(t => t.label);
    },
    activeTabLabel() {
      return this.tabs.find(t => t.key === this.activeTab)?.label || this.tabs[0]?.label;
    },
  },
  methods: {
    handleTabSelect(label) {
      const tab = this.tabs.find(t => t.label === label);
      if (tab) this.activeTab = tab.key;
    },
  },
};
</script>
